import { createAsyncThunk } from "@reduxjs/toolkit";
import { HOSTNAME } from "../configs/Domain";
import { prepareJsonPayload } from "../store/utils";
import { handleError } from "./_apiUtils";

// Slightly extended apiRequest to accept an optional userId (for the headers).
const apiRequest = async (url, method, data) => {
    console.log(url, method, data);
  const response = await fetch(
    url,
    prepareJsonPayload({
      method,
      data
    })
  );
  console.log(response);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || `Failed to ${method} data`);
  }
  return response.json();
};

/**
 * GET /clients
 * Fetch all clients for the authenticated advisor.
 * Skip fetching if we already have clients loaded.
 */
export const fetchAllClients = createAsyncThunk(
  "clients/fetchAll",
  async (_, { rejectWithValue, getState }) => {
    try {
      // Check if we already have clients loaded
      const currentClients = getState().clients.items;
      if (currentClients && currentClients.length > 0) {
        // Return existing clients to avoid unnecessary fetch
        return currentClients;
      }

      const url = `${HOSTNAME}/clients/list`;
      const resp = await apiRequest(url, "GET", null);
      return resp;
    } catch (error) {
      console.log('rejected', error);
      return handleError(error, rejectWithValue);
    }
  }
);

/**
 * GET /clients/:client_id
 * Fetch a single client by ID.
 * Skip fetching if we already have the full client document.
 */
export const fetchClient = createAsyncThunk(
  "clients/fetchClient",
  async (clientId, { rejectWithValue, getState }) => {
    try {
      // Check if we already have the full client document
      const currentClient = getState().clients.current;
      if (currentClient &&
          currentClient.client_id === clientId &&
          currentClient._isFull) {
        // Return existing client to avoid unnecessary fetch
        return currentClient;
      }

      const url = `${HOSTNAME}/clients/${clientId}`;
      return await apiRequest(url, "GET", null);
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

/**
 * POST /clients
 * Create a new client.
 * The `newClientData` object should match the expected shape of your ClientDocument.
 */
export const createClient = createAsyncThunk(
  "clients/create",
  async (newClientData, { rejectWithValue, getState }) => {
    try {
      const url = `${HOSTNAME}/clients/create`;
      return await apiRequest(url, "POST", newClientData);
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

/**
 * PUT/PATCH /clients/:client_id
 * Update an existing client by ID.
 * The `updateData` object contains only the fields you want to update.
 */
export const updateClient = createAsyncThunk(
  "clients/update",
  async ({ clientId, updateData }, { rejectWithValue, getState }) => {
    try {
      const url = `${HOSTNAME}/clients/${clientId}`;
      return await apiRequest(url, "PUT", updateData);
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

/**
 * DELETE /clients/:client_id
 * Remove a client by ID.
 */
export const removeClient = createAsyncThunk(
  "clients/remove",
  async (clientId, { rejectWithValue, getState }) => {
    try {
      const url = `${HOSTNAME}/clients/${clientId}`;
      return await apiRequest(url, "DELETE", null);
    } catch (error) {
      return handleError(error, rejectWithValue);
    }
  }
);

